// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__input___TZfnM {
}

.styles__localHeader___FESu_ {
}

.styles__localHeaderInner___xcMYE {
}

.styles__contentContainer___LiOPs {
  display: flex;
  flex-direction: column;
}

.styles__eventsTable___kwuUg {
  width: 100%;
}

.styles__nextActionsTable___kaVg5 {
  width: 80%;
  cursor: pointer;
}

.styles__section___uhg5_ {
  min-height: 300px;
}

.styles__sectionTitle___rsdfp {
  margin-bottom: 20px;
}

.styles__tableWrapper___Or9er {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__tableWrapper___Or9er:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__tableWrapper___Or9er:last-child {
  margin-right: 0;
}

.styles__tableWrapper___Or9er:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__tableWrapper___Or9er:nth-child(3n + 1) {
  clear: both;
}

.styles__notesWrapper___I1AmH {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__notesWrapper___I1AmH:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__notesWrapper___I1AmH:last-child {
  margin-right: 0;
}

.styles__notesWrapper___I1AmH:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__notesWrapper___I1AmH:nth-child(3n + 1) {
  clear: both;
}

.styles__row___UEznR {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__inputWrapper___HVU5w {
  position: relative;
  display: flex;
  margin: 0 0 10px;
  width: 100%;
}

.styles__searchInput___m43IG {
  width: 240px;
}

/* float export link to the right */
.styles__exportLink___nkrvZ {
  position: absolute;
  right: 0;
  top: 0;
  padding: 20px 10px 0;
  box-shadow: none;
  cursor: pointer;
}

/* BTE note: I don't know why this works but...CSS is weird. */
.styles__fullScreen___phDGw {
  width: calc(99.9% * 3/3 - (30px - 30px * 3/3));
}
.styles__fullScreen___phDGw:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__fullScreen___phDGw:last-child {
  margin-right: 0;
}
.styles__fullScreen___phDGw:nth-child(3n) {
  margin-right: 0;
  float: right;
}
.styles__fullScreen___phDGw:nth-child(3n + 1) {
  clear: both;
}
@media only screen and (max-width: 768px) {
.styles__fullScreen___phDGw {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}
.styles__fullScreen___phDGw:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}
.styles__fullScreen___phDGw:last-child {
    margin-right: 0;
}
.styles__fullScreen___phDGw:nth-child(1n) {
    margin-right: 0;
    float: right;
}
.styles__fullScreen___phDGw:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__oneThird___lEuEf {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___lEuEf:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___lEuEf:last-child {
  margin-right: 0;
}

.styles__oneThird___lEuEf:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___lEuEf:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___lEuEf {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___lEuEf:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___lEuEf:last-child {
    margin-right: 0;
}

.styles__oneThird___lEuEf:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___lEuEf:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__clearIcon____UZLg {
  position: absolute;
  top: 12px;
  right: 16px;
  width: 10px;
  color: #ccc;
  cursor: pointer;
}

.styles__tabsContainer___os0ku {
  /* display: flex;
  flex-direction: column; */
  width: 100%;
  background-color: antiquewhite;
}

.react-tabs__tab--selected {
    font-weight: 600;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    border-bottom: 3px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    margin-bottom: -3px;
  }

.react-tabs__tab {
    opacity: 1;
    height: 50px;
    cursor: pointer;
    padding: 16px 10px;
    text-transform: capitalize;
  }

.styles__tabList___Otopw {
  background: none;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  height: 100%;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-flow: wrap;
  list-style: none;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  margin: 10px 0 24px;
  padding: 0;
}

.styles__button___y9yJX {
  margin-left: 20px;
}

.styles__button___y9yJX:first-child {
    margin-left: 0;
  }

.styles__buttonLocal___lMS2f {
  margin-left: 8px;
}

.styles__buttonLocal___lMS2f:first-child {
    margin-left: 0;
  }

.styles__buttonLocal___lMS2f.styles__disabled___9bKZg {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Closings/components/Main/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EAEE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,8CAAgB;AAKlB;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;AANA;EACE,eAAgB;AAKlB;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;AANA;EACE,WAAgB;AAKlB;AAHE;AAHF;IAII,8CAAkB;AAEtB;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;AANA;IAII,eAAkB;AAEtB;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;2BACyB;EACzB,WAAW;EACX,8BAA8B;AAChC;;AAGE;IACE,gBAAgB;IAChB,mDAAW;IACX,qEAA+B;IAC/B,mBAAmB;EACrB;;AAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0BAA0B;EAC5B;;AAGF;EACE,gBAAgB;EAChB,mDAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qEAAoC;EACpC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EAEE,iBAAiB;AAKnB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,gBAAgB;AAKlB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;AACf","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: 'styles/colors.css';\n@value gtGPT, gtBlue, textLight, gtBlueLight, borderColor, gtRed, gtGrayLight, gtGreen, text, textDark from colors;\n\n.input {\n  composes: input from helpers;\n}\n\n.localHeader {\n  composes: localHeader from helpers;\n}\n\n.localHeaderInner {\n  composes: localHeaderInner from helpers;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: flex;\n  flex-direction: column;\n}\n\n.eventsTable {\n  width: 100%;\n}\n\n.nextActionsTable {\n  width: 80%;\n  cursor: pointer;\n}\n\n.section {\n  composes: section from helpers;\n  min-height: 300px;\n}\n\n.sectionTitle {\n  margin-bottom: 20px;\n}\n\n.tableWrapper {\n  lost-column: 2/3;\n}\n\n.notesWrapper {\n  lost-column: 1/3;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  margin: 0 0 10px;\n  width: 100%;\n}\n\n.searchInput {\n  composes: input from helpers;\n  width: 240px;\n}\n\n/* float export link to the right */\n.exportLink {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 20px 10px 0;\n  box-shadow: none;\n  cursor: pointer;\n}\n\n/* BTE note: I don't know why this works but...CSS is weird. */\n.fullScreen {\n  lost-column: 3/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.clearIcon {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  width: 10px;\n  color: #ccc;\n  cursor: pointer;\n}\n\n.tabsContainer {\n  /* display: flex;\n  flex-direction: column; */\n  width: 100%;\n  background-color: antiquewhite;\n}\n\n:global {\n  .react-tabs__tab--selected {\n    font-weight: 600;\n    color: text;\n    border-bottom: 3px solid gtBlue;\n    margin-bottom: -3px;\n  }\n\n  .react-tabs__tab {\n    opacity: 1;\n    height: 50px;\n    cursor: pointer;\n    padding: 16px 10px;\n    text-transform: capitalize;\n  }\n}\n\n.tabList {\n  background: none;\n  color: textLight;\n  height: 100%;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-flow: wrap;\n  list-style: none;\n  border-bottom: 1px solid borderColor;\n  margin: 10px 0 24px;\n  padding: 0;\n}\n\n.button {\n  composes: button from helpers;\n  margin-left: 20px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonLocal {\n  margin-left: 8px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonLocal.disabled {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `'styles/colors.css'`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"input": `styles__input___TZfnM ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"localHeader": `styles__localHeader___FESu_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeader"]}`,
	"localHeaderInner": `styles__localHeaderInner___xcMYE ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeaderInner"]}`,
	"contentContainer": `styles__contentContainer___LiOPs ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"eventsTable": `styles__eventsTable___kwuUg`,
	"nextActionsTable": `styles__nextActionsTable___kaVg5`,
	"section": `styles__section___uhg5_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionTitle": `styles__sectionTitle___rsdfp`,
	"tableWrapper": `styles__tableWrapper___Or9er`,
	"notesWrapper": `styles__notesWrapper___I1AmH`,
	"row": `styles__row___UEznR`,
	"inputWrapper": `styles__inputWrapper___HVU5w`,
	"searchInput": `styles__searchInput___m43IG ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"exportLink": `styles__exportLink___nkrvZ`,
	"fullScreen": `styles__fullScreen___phDGw`,
	"oneThird": `styles__oneThird___lEuEf`,
	"clearIcon": `styles__clearIcon____UZLg`,
	"tabsContainer": `styles__tabsContainer___os0ku`,
	"tabList": `styles__tabList___Otopw`,
	"button": `styles__button___y9yJX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonLocal": `styles__buttonLocal___lMS2f`,
	"disabled": `styles__disabled___9bKZg`
};
export default ___CSS_LOADER_EXPORT___;
